import { render } from "./StoryType.vue?vue&type=template&id=114adc0a&lang=html"
import script from "./StoryType.vue?vue&type=script&lang=js"
export * from "./StoryType.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__